import WA from "@/miniapp/tg";
import AnalyticsService from "@emcd-shared/analytics-service";
import { useUserStore } from "@/stores/user";
import { parseUtmFromTgStartParam } from "../parseUtmFromTgStartParam";
import { API } from "@/api/constants";
import { Request } from "@/api/request";
import { uuid } from "vue3-uuid";
import { parseRefIdFromTgStartParam } from "../parseRefIdFromTgStartParam";
import { parseSegmentIdFromTgStartParam } from "../parseSegmentIdFromTgStartParam";
import store from "@/store";

export function getRegistrationAnalyticsData() {
  const startParam = WA.initDataUnsafe?.start_param;
  const utmParams = startParam ? parseUtmFromTgStartParam(startParam) : {};

  // ctx is snapshotted once on init, before async Segment/GA cookies are set — re-read now.
  AnalyticsService?.setupCtx?.();

  const segmentAnonymousId =
    window.analytics?.user?.()?.anonymousId?.() ||
    AnalyticsService?.ctx?.anonymousId ||
    null;

  const segmentId =
    AnalyticsService?.ctx?.segmentID ||
    parseSegmentIdFromTgStartParam(startParam) ||
    null;

  return {
    segmentAnonymousId,
    segmentId,
    gaId: AnalyticsService?.ctx?.gid || null,
    yid: AnalyticsService?.ctx?.yid || null,
    tgUserId: WA.app?.initDataUnsafe?.user?.id || null,
    platform: WA.app?.platform || null,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    viewportSize: `${window.innerWidth}x${window.innerHeight}`,
    isTouchDevice: "ontouchstart" in window || navigator.maxTouchPoints > 0,
    ...utmParams,
  };
}

export function sendAnalytics(name, params) {
  if (window.emcd.AnalyticsService && window.analytics) {
    AnalyticsService.track(name, {
      ...params,
      tg_user_id: WA.app?.initDataUnsafe?.user?.id,
      product: "tma",
    });
  }
}

export const baseAnalytics = {
  initAnalyticsClient() {
    localStorage.removeItem("isSessionEnterSentToSegment");
    localStorage.removeItem("isUtmRedirected");
    if (window.AnalyticsClient) {
      window.AnalyticsClient.init(WA.app?.initDataUnsafe?.user?.id);
    }
  },
  identify() {
    const { userData } = useUserStore();
    if (window.analytics && userData) {
      // segment_id из auth-профиля (auth/analyticsUserId). JWT-fallback: профиль
      // (loadProfile) может ещё не загрузиться к моменту identify (appOpened в
      // Dashboard onMounted), иначе identify(undefined) сломал бы identity.
      const analyticsUserId =
        store.getters["auth/analyticsUserId"] || userData.segment_id;
      window.analytics.identify(analyticsUserId, {
        email: userData.email,
        username: userData.username,
        id: userData.id,
      });
    }
  },
  appOpened() {
    localStorage.removeItem("session_id");
    this.identify();
    sendAnalytics("page_view", {
      event: "session_start",
      screen: "dashboard",
      ...(WA.initDataUnsafe.start_param
        ? parseUtmFromTgStartParam(WA.initDataUnsafe.start_param)
        : {}),
      refId: parseRefIdFromTgStartParam(WA.initDataUnsafe.start_param),
    });
    Request.post(
      `${API.TMA_BACKEND_URL}/check-in`,
      {
        init_data: WA.initData,
        utmParams: {
          ...(WA.initDataUnsafe.start_param
            ? parseUtmFromTgStartParam(WA.initDataUnsafe.start_param)
            : {}),
        },
        refId: parseRefIdFromTgStartParam(WA.initDataUnsafe.start_param),
        segmentId: parseSegmentIdFromTgStartParam(
          WA.initDataUnsafe.start_param,
        ),
      },
      {},
      { disablePreloader: true },
    );
    localStorage.setItem("isSessionEnterSentToSegment", true);
    localStorage.setItem("session_id", uuid.v4());
  },
  authStart() {
    // sendAnalytics("auth_start");
  },
  authSuccess() {
    // sendAnalytics("auth_success");
  },
  authFailure() {
    // sendAnalytics("auth_failure");
  },
  navbarNavigate(item, routeName) {
    sendAnalytics(`navigate`, {
      navigate_name: item,
      event: "navigate",
      screen: routeName,
    });
  },
  appsNavigate(item) {
    sendAnalytics(`click`, {
      button_name: item,
      screen: "apps",
      event: "click",
    });
  },
  pageView(page, screen) {
    sendAnalytics("page_view", {
      event: "page_view",
      screen: screen,
      page: page,
    });
  },
};
